<script>
    import { fade } from 'svelte/transition';
    import {link , push } from 'svelte-spa-router'
    import fetchData from '../api.js';
    import { validateFields }  from '../base/validation.js';
    import {  sendPrintJob}  from '../base/printer.js';
    import { systemUrl } from '../api.js';
    import UserStore from '../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount , onDestroy , tick } from 'svelte';
    import Header from '../components/Header.svelte'; 
    import TopInfo from '../components/TopInfo.svelte'; 
    import Preloader from '../components/Preloader.svelte'; 
    //import App from '../App.svelte';

    let isLoading = true; 
    let print_url = '';
    let create_new = false;
    
    

    export let params;   

    let order_id = params.shipment_id
    
    let tracking_number = false;

    $: {
        
        if (shipment.destination.shipment_type==2) {          
            getStores(postData)            
        }
    }

    $: location_id = shipment.destination.datalogics_location;


    const getStores = async () => {

        let postData = {};
        postData.platform_id = shipment.destination.datalogics_platform_id;
        postData.action = 'crm_stores_by_platform';
        postData.token = $UserStore.data

        let response = await fetchData(postData);

        //console.log('response',response);

        if (response.data) {

            //stores = response.data; 

            const keyValueArray = Object.entries(response.data);

            // Sort the array by keys
            keyValueArray.sort((a, b) => a[0].localeCompare(b[0]));

            // Convert the sorted array back to an object
            stores = Object.fromEntries(keyValueArray);


            if (shipment.destination.datalogics_n_code!='') {
                for(let key in stores) {
                    stores[key].filter((store)=> {
                        
                        if (store.n_code == shipment.destination.datalogics_n_code) {
                            
                            shipment.destination.datalogics_n_code_city = store.city

                            console.log(stores[shipment.destination.datalogics_n_code_city]);
                        }
                    })
                }
            }

        }
    }    

    let stores = [];
    let settings = {};
    let general_settings = {};
    let shipping_methods = [];
    let locations = [];
    let selected_shipping_method = {}
    


    let shipment = {
        shipping_method : '',
        status : [],
        items : [],
        shipment_id : '',
        order_name : '',
        platform_id : '',
        order_id : '',
        general_comments : '',
        reference : '',
        origin : {
            // fullname : '',
            // phone : '',
            // email : '',
            // city : '',
            // address : '',
            // house : '',
            // entrance : '',
            // apartment : '',
            // floor : '',
            // door : '',
            comments : ''
        },
        destination : {
            datalogics_fullname : '',
            datalogics_phone : '',
            datalogics_email : '',
            datalogics_city : '',
            datalogics_address : '',
            datalogics_house : '',
            datalogics_entrance : '',
            datalogics_apartment : '',
            datalogics_floor : '',
            datalogics_door : '',
            datalogics_shipment_type : "1",
            datalogics_shipment_select : "1",
            datalogics_govina_sum : '',
            datalogics_comments : '',
            datalogics_n_code : '',
            datalogics_n_code_city : '',
            datalogics_platform_id : '',
            datalogics_reference : '',
            datalogics_location : 0
            
        }
    }

    // if ($meta->key=='datalogics_carrier_type') { $datalogics_carrier_type = $meta->value; }
    // if ($meta->key=='datalogics_shipment_type') { $datalogics_shipment_type = $meta->value; }
    // if ($meta->key=='datalogics_packs') { $packages = $meta->value; }
    // if ($meta->key=='datalogics_comment') { $products_shipping_comments .= ' '.$meta->value; }
    // if ($meta->key=='datalogics_location') { $location = $meta->value; }
    // if ($meta->key=='datalogics_platform_id') { $datalogics_platform_id = $meta->value; }     

    $: if (params.shipment_id !== order_id) {
        order_id = params.shipment_id;
        fetchOrder();

    }

    onMount(async() => {
        fetchOrder()        
    })


    const fetchOrder = async() => {


        if (!$UserStore || !$UserStore.data){
            push('/login');
            return;
        }

        locations = $UserStore.settings?.shipping_settings?.datalogics_update_inventory_locations ?? []

        print_url = systemUrl + '/label?token=' + $UserStore.data + "&order_id=";


        settings = $UserStore.settings.shipping_settings;
        general_settings = settings;


        console.log('general_settings',general_settings)
        let type = typeof settings.shipping_method ;
        if (settings.shipping_method && settings.shipping_method.length) {
            shipping_methods = settings.shipping_method;
            selected_shipping_method = shipping_methods[0]
        } else {
            shipping_methods = [];
        }   

       

        shipment.destination.datalogics_platform_id = selected_shipping_method.shipping_push_supplier; 

        // shipment.origin = {
        //     fullname : settings.shipping_push_supplier_name,
        //     phone : settings.shipping_push_supplier_phone,
        //     email : settings.shipping_push_supplier_email,
        //     city : settings.shipping_push_supplier_city,
        //     address : settings.shipping_push_supplier_street,
        //     house : settings.shipping_push_supplier_house,
        //     entrance : settings.shipping_push_supplier_entrace,
        //     apartment : settings.shipping_push_supplier_apartment,
        //     floor : settings.shipping_push_supplier_floor,
        //     door : settings.shipping_push_supplier_door,
        //     comments : '',
        // };    
        
        // if (!settings.shipping_push_supplier_name) {
        //     shipment.origin.fullname = $UserStore.settings.shipping_settings.shipping_push_supplier_name;
        // }
        // if (!settings.shipping_push_supplier_house) {
        //     shipment.origin.house = $UserStore.settings.shipping_settings.shipping_push_supplier_house;
        // }
        // if (!settings.shipping_push_supplier_city) {
        //     shipment.origin.city = $UserStore.settings.shipping_settings.shipping_push_supplier_city;
        // }
        
        // if (!settings.shipping_push_supplier_street) {
        //     shipment.origin.address = $UserStore.settings.shipping_settings.shipping_push_supplier_street;
        // }
        
        
        if (params && params.shipment_id && params.shipment_id!="-1") {

            let postData = {};       

            postData.action = 'crm_get_shipment';
            postData.token = $UserStore.data
            postData.details = 1;
            
            postData.shipment_id = params.shipment_id
            let response = await fetchData(postData);

            if (response.data) {

                let shipping_data = response.data[0];

                //console.log('shipping_data',shipping_data)
                shipment.shipping_method = shipping_data.shipping_method
                shipment.status = shipping_data.status
                shipment.items = shipping_data.items
                for(var key in shipment.items) {
                    //console.log(shipment.items[key])
                    shipment.items[key].quantity_scanned = 0;
                    shipment.items[key].scanned_status = 0;
                }

                tracking_number = shipping_data.shipment_id;
                shipment.shipment_id = shipping_data.shipment_id;
                shipment.order_name = shipping_data.order_name;
                shipment.order_id = shipping_data.order_id;
                //shipment.platform_id = shipping_data.platform_id

                shipment.destination.datalogics_fullname = shipping_data.client_name;
                shipment.destination.datalogics_phone = shipping_data.client_phone;
                shipment.destination.datalogics_email = shipping_data.client_email;
                shipment.destination.datalogics_city = shipping_data.client_city;
                shipment.destination.datalogics_address = shipping_data.client_street;
                shipment.destination.datalogics_house = shipping_data.client_house;
                shipment.destination.datalogics_entrance = shipping_data.shipping_entrance;
                shipment.destination.datalogics_apartment = shipping_data.shipping_apartment;
                shipment.destination.datalogics_floor = shipping_data.shipping_floor;
                shipment.destination.datalogics_door = shipping_data.shipping_door;
                shipment.destination.datalogics_shipment_type = "1";
                shipment.destination.datalogics_shipment_select = "1";
                shipment.destination.datalogics_govina_sum = '';
                shipment.destination.datalogics_comments = shipping_data.comments;
                shipment.destination.datalogics_n_code =(shipping_data.ncode!='') ?  parseInt(shipping_data.ncode) : '';
                shipment.destination.datalogics_n_code_city = '';
                shipment.destination.datalogics_location = 0;
                shipment.destination.datalogics_reference = shipping_data.order_name;

                if (shipment.destination.datalogics_n_code!='') {
                    shipment.destination.datalogics_shipment_select = "2";
                }
            
                


                // postData.action = 'crm_get_shipments';
                // postData.token = $UserStore.data
                // let data = await fetchData(postData);
                // orders = data.data.filter((item) => {
                //     const dateTimeParts = item.date.split(" ");
                //     item.current_date = dateTimeParts[0];
                //     item.current_time = dateTimeParts[1];
                //     if (item.shipment_id.startsWith("RG")) {
                //         item.type = 2; 
                //         pickup_count++;
                //     } else {
                //         item.type = 1; 
                //         door_count++;
                        
                //     }
                //     return true; 
                // });  



                
                
                

            }

        }

        getStores()

        isLoading = false; 

        await tick();
        let barcodeId = '';
        for(var key in shipment.items) {
            if (shipment.items[key].sku!='') {
                console.error(shipment.items[key].sku)
                barcodeId = "#barcode" + key;
                if (document.querySelector(barcodeId)) {
                    JsBarcode(barcodeId, shipment.items[key].sku, {
                        width: 2, 
                        height: 20, 
                    });
                }
            }
        }


        document.addEventListener('keydown', handleKeyDown);


        
        
        
    }


    onDestroy(() => {
        document.removeEventListener('keydown', handleKeyDown);
    });

    const CancelShipment = async() => {


        let postData = {}; 
        postData.action = 'crm_cancel_shipment';   
        postData.token = $UserStore.data;    
        postData.order_id = shipment.order_id;
        let response = await fetchData(postData);
        console.log('CancelShipment',response);
        if (response.data) {
            tracking_number = '';
            shipment.shipment_id = '';
        }

    }

    const handleSubmit = async() => {
        
        if (create_new) {
            
            if(!confirm('להזמנה זו כבר נוצר שטר מטען, במידה ותאשרו יווצר להזמנה זו שטר מטען נוסף')) {
                return;
            }
        }

        if (!validateFields(shipment.destination)) {
            alert('יש מלא את כל השדות חובה')
            return;
        }


        isLoading = true;
        

        let postData = {}; 
        postData.action = 'crm_create_shipment';   
        postData.token = $UserStore.data;    
        postData.order_id = shipment.order_id;
        //postData.platform_id = shipment.platform_id;
        postData.data = shipment.destination;
        if (create_new) {
            postData.create_new = true;
        }
        let response = await fetchData(postData);
        console.log('handleSubmit',response);
        if (response.data) {
            tracking_number = response.data.shipment_id;
            shipment.shipment_id = response.data.shipment_id;

            // BulkPrint();
        }

        isLoading = false;
    }


    let scannedBarcode = '';

    function handleKeyDown(event) {

        // if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA' || event.target.isContentEditable) {
        //     return;
        // }

        // Check if the key pressed is a number or Enter
        if (/^\d$/.test(event.key)) {

            scannedBarcode += event.key;

        } else if (event.key === 'Enter') {

            console.log('scannedBarcode',scannedBarcode)

            if (scannedBarcode.startsWith('E')) {
                scannedBarcode = scannedBarcode.substring(1);
            }

            //alert(scannedBarcode);

            let barcodePassed = false;
            let barcodeKey = '';

            for(var key in shipment.items) {
                if (shipment.items[key].sku==scannedBarcode) {
                    barcodePassed = true;
                    barcodeKey = key
                }
            }

            if (!barcodePassed) {
                // Handle the case when the note does not exist
                alert('ברקוד אינו קיים ברשימה');
                scannedBarcode = '';
                return;
            }

            scannedBarcode = '';

            handleItemsScannCount(barcodeKey)
            
        }
    }

    function handleItemsScannCount(barcodeKey) {


        shipment.items[barcodeKey].quantity_scanned++;
        if (shipment.items[barcodeKey].quantity_scanned>=shipment.items[barcodeKey].quantity) {
            shipment.items[barcodeKey].scanned_status = 2;
            shipment.items[barcodeKey].quantity_scanned = shipment.items[barcodeKey].quantity;
        } else {
            shipment.items[barcodeKey].scanned_status = 1;
        }

        shipment.items = [...shipment.items]


        const allItemsHaveStatus2 = Object.keys(shipment.items).every(function(key) {
            return shipment.items[key].scanned_status === 2;
        });


        if (typeof settings.create_shipment_after_scan!== undefined && settings.create_shipment_after_scan=="1") {

            if (allItemsHaveStatus2) {

                create_new = false; 
                handleSubmit();
                setTimeout(function(){
                    sendPrintJob(order_id,$UserStore);
                },7000)

                window.history.back();
                    
            }

        }

    }


    const BulkPrint = () => {
        
        const printWindow = window.open(print_url + order_id, '_blank');

        if (typeof settings.automatic_print_after_creation_of_tracking!== undefined && settings.automatic_print_after_creation_of_tracking=="1") {

            printWindow.onload = function () {
                printWindow.print();
            };

        }

    }




    
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">    
        <TopInfo/>
        <div class="shipment">

            <a href="{print_url}{shipment.order_id}&details=1" target="_blank">
                <i class="fa-solid fa-print red-color"></i>
                {$_('shipment.full_details')} 
            </a>

            {#if shipment.shipment_id}
            <div class="shipment_notification">
                {$_('shipment.your_tracking_number_created')} 
                <a href="{print_url}{shipment.order_id}" target="_blank">
                    <i class="fa-solid fa-print red-color"></i> 
                    <strong>{shipment.shipment_id}</strong>
                    {$_('shipment.print_click_here')} 
                </a>

                <!-- <a href="{print_url}{shipment.order_id}&details=1" target="_blank">
                    <i class="fa-solid fa-print red-color"></i> 
                    <strong>{shipment.shipment_id}</strong>
                    {$_('shipment.full_details')} 
                </a> -->
            </div>            
            {/if}
            <h1 class="text-[20px] font-bold">
                {#if shipment.order_id}
                    {$_('shipment.order_name')}: {shipment.order_name} {#if shipment.order_name!=shipment.order_id}({shipment.order_id}){/if}
                {:else}
                    {$_('shipment.shipment_name')}
                {/if}
            </h1>  
            {#if !locations[location_id]}
                <div>
                    {$_('shipment.locations_msg')}
                    <a class="link" use:link href="/locations">{$_('shipment.edit_locations')}</a>
                </div>
            {:else}
                {#if shipment.shipment_id && shipment.shipment_id!=''}
                <div class="shipment-status">
                    <div class="shipment_header">
                        <i class="fa-solid fa-street-view"></i> {$_('shipment.statuses')}
                    </div> 
                    <div class="shipment-items-box">
                        <div class="shipment-items-line shipment-items-line-head shipment-status-line">
                            <div>{$_('shipment.date')}</div>
                            <div>{$_('shipment.status')}</div>
                        </div>
                        {#each shipment.status as item}
                        <div class="shipment-items-line shipment-status-line">                            
                            <div>{item.date}</div>
                            <div>{item.status}</div>
                        </div>
                        {/each}
                    </div>
                </div>
                {/if}
                {#if shipping_methods.length>1}
                <div class="shipping_companies mt-5">
                    <label>{$_('companies.shipping_company')}</label>
                    <select bind:value={shipment.destination.datalogics_platform_id}>
                    {#each shipping_methods as method}
                        <option value="{method.shipping_push_supplier}">{platforms[+method.shipping_push_supplier].name}</option>
                    {/each}
                    </select>
                </div>      
                {/if}
                {#if ((settings.enable_scanning_products && settings.enable_scanning_products=="1") || (general_settings.enable_scanning_products && general_settings.enable_scanning_products=="1")) && shipment.items && shipment.items.length}
                <div class="shipment-items">
                    <div class="shipment_header">
                        <i class="fa-solid fa-barcode"></i> {$_('items.items')}
                    </div> 
                    <div class="shipment-items-box">
                        <div class="shipment-items-line shipment-items-line-head">
                            <div>{$_('items.sku')}</div>
                            <div>{$_('items.name')}</div>
                            <div>{$_('items.qty')}</div>
                            <div>{$_('items.qty_scanned')}</div>
                            <div>{$_('items.scanned_status')}</div>
                        </div>
                        {#each shipment.items as item,key}
                        <div class="shipment-items-line">
                            <div>
                                {item.sku}
                                <!-- {#if item.sku}
                                <svg id="barcode{key}"></svg>
                                {/if} -->
                            </div>
                            <div>{item.name}</div>
                            <div><div class="qty">{item.quantity}</div></div>
                            <div><div class="qty qty-scanned">{item.quantity_scanned}</div></div>
                            <div>
                                <div class="badge badge{item.scanned_status}" on:click={()=> { handleItemsScannCount(key) } }>
                                {#if item.scanned_status==0}
                                    {$_('items.not_scanned')}
                                {:else if item.scanned_status==1}
                                    {$_('items.partial_scanned')}
                                {:else}
                                    {$_('items.scanned')}
                                {/if}
                                </div>
                            </div>
                        </div>
                        {/each}
                    </div>
                    <!-- <div class="items-buttons">
                        <div class="shipment-flex-button">
                            <div class="create_button">{$_('items.create_invoice')}</div>
                        </div> 
                    </div> -->
                </div>
                {/if}
                <div class="shipment-flex">
                    <div class="shipment_origin">
                        <div class="shipment_header">
                            <i class="fa-regular fa-map"></i> {$_('shipment.origin')}
                        </div>   
                        <div class="input_box">
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.location_name')} <a class="link" use:link href="/locations">{$_('shipment.edit_locations')}</a></label>      
                                <select bind:value={shipment.destination.datalogics_location}>
                                {#each locations as location,index}
                                    {#if location.enabled}
                                    <option value="{index}">{location.name} - {location.street} {location.house} , {location.city} </option>
                                    {/if}
                                {/each}
                                </select>
                            </div>
                        </div>
                        <div class="input_box">      
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.name')}</label>
                                <input type="text" bind:value={locations[location_id].name} disabled>
                            </div>
                        </div>
                        <div class="input_box">
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.phone')}</label>
                                <input type="text" bind:value={locations[location_id].phone} disabled>
                            </div>             
                            <div class="input_con">
                                <label>{$_('shipment.email')}</label>
                                <input type="text" bind:value={locations[location_id].email} disabled>
                            </div>
                        </div>
                        <div class="input_box">
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.city')}</label>
                                <input type="text" bind:value={locations[location_id].city} disabled>
                            </div>
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.street')}</label>
                                <input type="text" bind:value={locations[location_id].street} disabled>
                            </div>
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.house')}</label>
                                <input type="text" bind:value={locations[location_id].house} disabled>
                            </div>
                        </div>
                        <!-- 
                        <div class="input_box">
                            
                            <div class="input_con">
                                <label>{$_('shipment.entrance')}</label>
                                <input type="text" bind:value={shipment.origin.entrace}>
                            </div>
                            <div class="input_con">
                                <label>{$_('shipment.floor')}</label>
                                <input type="text" bind:value={shipment.origin.floor}>
                            </div>
                            <div class="input_con">
                                <label>{$_('shipment.apartment')}</label>
                                <input type="text" bind:value={shipment.origin.apartment}>
                            </div>
                        </div>
                         -->
                        <!-- <div class="input_box">
                            <div class="input_con">
                                <label>{$_('shipment.origin_comments')}</label>
                                <input type="text" bind:value={shipment.origin.comments}>
                            </div>                    
                        </div> -->
                    </div>
                    <div class="shipment_destination">
                        <div class="shipment_header">
                            <i class="fa-solid fa-location-dot"></i> {$_('shipment.destination')}
                        </div> 
                        <div class="input_box">
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.shipping_type')}</label>      
                                <select bind:value={shipment.destination.datalogics_shipment_type}>
                                    <option value="1"> {$_('shipment.delivery')}</option>
                                    <option value="2"> {$_('shipment.double_govina')}</option>
                                    <option value="3"> {$_('shipment.pickup')}</option>
                                </select>
                            </div>
                            {#if shipment.destination.datalogics_shipment_type=="2"}
                            <div class="input_con">
                                <label>{$_('shipment.govina_sum')}</label>
                                <input type="text" bind:value={shipment.destination.datalogics_govina_sum}>
                            </div>
                            {/if}
                        </div>
                        <div class="input_box">      
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.name')}</label>
                                <input type="text" bind:value={shipment.destination.datalogics_fullname} class:input_empty_error={shipment.destination.datalogics_fullname === ''}>
                            </div>
                        </div>
                        <div class="input_box">
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.phone')}</label>
                                <input type="text" bind:value={shipment.destination.datalogics_phone} class:input_empty_error={shipment.destination.datalogics_phone === ''}>
                            </div>             
                            <div class="input_con">
                                <label>{$_('shipment.email')}</label>
                                <input type="text" bind:value={shipment.destination.datalogics_email}>
                            </div>
                        </div>
                        {#if Object.keys(stores).length && platforms[shipping_push_supplier] && platforms[shipping_push_supplier].pickup && platforms[shipping_push_supplier].pickup=="1"}
                        <div class="input_box">
                            <div class="input_con radio">
                                <input id="shipment_type1" type="radio" name="shipment_type" bind:group={shipment.destination.datalogics_shipment_select} value="1">
                                <label for="shipment_type1"><i class="fa-solid fa-asterisk"></i> {$_('shipment.specific_location')}</label>
                            </div>
                            <div class="input_con radio">
                                <input id="shipment_type2" type="radio" name="shipment_type" bind:group={shipment.destination.datalogics_shipment_select}  value="2">
                                <label for="shipment_type2"><i class="fa-solid fa-asterisk"></i> {$_('shipment.pudo')}</label>
                            </div>
                        </div>
                        {/if}
                        {#if shipment.destination.datalogics_shipment_select==1}
                        <div class="input_box">
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.city')}</label>
                                <input type="text" bind:value={shipment.destination.datalogics_city} class:input_empty_error={shipment.destination.datalogics_city === ''}>
                            </div>
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.street')}</label>
                                <input type="text" bind:value={shipment.destination.datalogics_address} class:input_empty_error={shipment.destination.datalogics_address === ''}>
                            </div>
                        </div>
                        <div class="input_box">
                            <div class="input_con">
                                <label>{$_('shipment.house')}</label>
                                <input type="text" bind:value={shipment.destination.datalogics_house}>
                            </div>
                            <div class="input_con">
                                <label>{$_('shipment.entrance')}</label>
                                <input type="text" bind:value={shipment.destination.datalogics_entrace}>
                            </div>
                            <div class="input_con">
                                <label>{$_('shipment.floor')}</label>
                                <input type="text" bind:value={shipment.destination.datalogics_floor}>
                            </div>
                            <div class="input_con">
                                <label>{$_('shipment.apartment')}</label>
                                <input type="text" bind:value={shipment.destination.datalogics_apartment}>
                            </div>
                        </div>
                        {:else}
                        <div class="input_box">
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.city')}</label>
                                <select bind:value={shipment.destination.datalogics_n_code_city}>
                                    <option value="">יש לבחור עיר</option>
                                    {#each Object.keys(stores) as item,index}
                                        <option value="{item}">{item}</option>
                                    {/each}
                                </select>
                            </div>
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.podu_location')}</label>
                                <select bind:value={shipment.destination.datalogics_n_code}>
                                    <option value="">יש לבחור ממס</option>
                                    {#if shipment.destination.datalogics_n_code_city!='' && stores[shipment.destination.datalogics_n_code_city].length}
                                        {#each stores[shipment.destination.datalogics_n_code_city] as item,index}
                                            <option value="{item.n_code}">{item.name} - {item.street} {item.house}</option>
                                        {/each}
                                    {/if}
                                </select>
                            </div>
                        </div>
                        {/if}
                        <!-- <div class="input_box">
                            <div class="input_con">
                                <label>{$_('shipment.destination_comments')}</label>
                                <input type="text" bind:value={shipment.destination.datalogics_comments}>
                            </div>                    
                        </div> -->
                    </div>            
                </div>   
                <div class="shipment-flex">
                    <div class="input_box">
                        <div class="input_con">
                            <label>{$_('shipment.general_comments')}</label>
                            <input type="text" bind:value={shipment.destination.datalogics_comments}>
                        </div>
                        <div class="input_con">
                            <label>{$_('shipment.reference')}</label>
                            <input type="text" bind:value={shipment.destination.datalogics_reference}>
                        </div>
                    </div>
                </div>    
                <!-- <div class="shipment-flex-button">
                    <div class="create_button" on:click={()=>{ create_new = false; handleSubmit(); }}>{$_('shipment.create_shipment')}</div>
                    {#if $UserStore.id==1601}
                    <div class="create_button red-notice" on:click={()=>{ create_new = true; handleSubmit(); }}>{$_('shipment.create_new_shipment')}</div>
                    {/if}
                </div>  -->
                <div class="orders-bulk-con">
                    {#if shipment.shipment_id >0 && platforms[shipping_push_supplier] && platforms[shipping_push_supplier].cancel && platforms[shipping_push_supplier].cancel=="1"}                    
                    <div class="button" on:click={()=> CancelShipment() }>{$_('shipment.cancel')}</div>
                    {/if}
                    <div class="button" on:click={()=>{ create_new = false; handleSubmit(); }}>{$_('shipment.create_shipment')}</div>
                     {#if $UserStore.id==1601 || $UserStore.id==2205}
                    <div class="button red-notice" on:click={()=>{ create_new = true; handleSubmit(); }}>{$_('shipment.create_new_shipment')}</div>
                    {/if}
                    <div class="button" on:click={()=> BulkPrint() }>{$_('shipment.print')}</div>
                </div>
            {/if}
        </div>
        
    </div>
</div>

<style>   

    
    .shipment-flex {
        text-align: center;
        display: flex;  
    }
    
    .shipment-flex > div {
        flex:1;
        padding:10px;
    }
    
    .shipment_header {
        color: var(--theme-one-color);
        padding: 10px 0;
        margin-bottom: 20px;
        /* border-radius: 10px; */
        font-size: 22px;
        text-align: right;
        border-bottom: 1px solid rgb(171 171 171);
    }
    
    
    .shipment_header i {
        color: rgb(73 73 73)
    }

    .shipment_notification {
        padding:10px;
        border:1px solid green;
        background-color: rgb(228, 255, 228);
        border-radius:10px;
        margin-bottom: 10px;
    }
    .shipment-items-box {
        display: table;
        width:100%;
        font-size: 14px;;
    }
    .shipment-items-line-head {
        font-weight: bold;
    }
    .shipment-items-line {
        display:table-row;
        width: 100%;        
    }
    .shipment-items-line > div {
        display:table-cell;
        border-bottom:1px solid rgb(171 171 171);  
        border-bottom:1px solid rgb(226, 226, 226);  
        padding:4px;
        border-collapse: collapse;;
        text-align: center;
    }
    .shipment-status-line > div {
        display:table-cell;
        border-bottom:1px solid rgb(226, 226, 226);  
        padding:4px;
        border-collapse: collapse;;
        text-align: right;
    }
    .shipment-status-line > div:first-child {
        width:200px;
    }
    .qty {
        background-color: #5b5b5b;
        color: white;
        border-radius: 5px;;
        padding:5px;
        display: inline-block;
        width: 20px;;
        text-align: center;
    }
    .qty-scanned {
        background-color: #262626;
    }
    .badge {
        width: 90px;
        background-color: #60a325;
        color: white;
        border-radius: 5px;;
        padding:5px 10px;
        display: inline-block;
    }
    .badge0 {
        background-color: var(--theme-one-color);
    }
    .badge1 {
        background-color: #234fe0;
    }

    @media screen and (max-width:600px) {
        .shipment-flex {
            text-align: center;
            display: flex;  
            flex-direction: column;
        }
    }

</style>